import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { GravunShell } from "../../gravun/layout/GravunShell";
import { useConfigurationLoader } from "../root/useConfigurationLoader";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <>
      <GravunShell>
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense
            fallback={
              <div className="flex flex-col gap-4">
                <Skeleton className="h-8 w-64" />
                <Skeleton className="h-40 w-full" />
              </div>
            }
          >
            {children}
          </Suspense>
        </ErrorBoundary>
      </GravunShell>
      <Notification />
    </>
  );
};
